import React, { Fragment } from 'react'
import classnames from 'classnames'
import store from '../../admin/store'
import {
    withRouterConnectWrapper,
    i18n,
} from '../../validator'
import Configurator from '../../configurator'
import SnIcon from '../../front/components/shared/sn-icon'

import {
    LoginButton,
    setSuccessAction,
} from '../nav/login-buttons'
import Button from '../../front/components/shared/sn-button'

const userDefaultLogo = '/images/man-silhouette.svg'
const logoSnect = '/images/sn-logo-new.svg'
const logoOstrava = '/images/ostrava/fajnovy-sport-logo.svg'
const logoOlomouc = '/images/olomouc/svol-nav-logo.svg'
const logoCheb = '/images/cheb/svch-nav-logo.svg'

import { setSystemRedirectLinks } from '../../admin/actions/system-redirect'
import {
    S_SPORTNECT,
    SFN_TYPE,
} from '../../consts'
import { sportnectNavDropdowns } from '../nav/dropdowns/sportnect'
import { citiesNavDropdowns } from '../nav/dropdowns/cities'
import { ImageResized } from '../shared/webp-image-resized'
import logout from '../../admin/actions/logout'
import Link from '../../front/components/shared/sn-link'

/**
 * Code is temporarily duplicated for SFN purposes
 *
 * @returns {*}
 */
@i18n()
class SFNHeader extends Configurator {
    static RESPONSIVE_MENU_WIDTH_BREAK = 1200

    constructor(props) {
        super(props)

        this.state = {
            showMenuResponsive: false,
            submenuOpen: false,
            isResponsiveMenu: this.isResponsiveMenu(),
            toggleResponsiveMenu: this.toggleResponsiveMenu,
            dropdowns: this.config.REACT_APP_SYSTEM === 'sportnect' ? sportnectNavDropdowns(props, this.config) : citiesNavDropdowns(props),
        }
    }

    componentDidMount() {
        window.addEventListener('resize', () => {
            this.setState({ isResponsiveMenu: this.isResponsiveMenu() })
        })
    }

    /**
     * Apply responsive?
     *
     * @returns {boolean}
     */
    isResponsiveMenu = () => window.innerWidth <= Navigator.RESPONSIVE_MENU_WIDTH_BREAK


    /**
     * Show / hide the responsive menu
     *
     * @param {boolean} forceStatus
     */
    toggleResponsiveMenu = (forceStatus = null) => {
        if (this.isResponsiveMenu()) {
            this.setState({ showMenuResponsive: forceStatus !== null ? forceStatus : !this.state.showMenuResponsive })
        }
    }

    /**
     * Render menu logo
     *
     * @returns {*}
     */
    renderMenuLogo = () => {
        const {
            authedUser,
            location,
        } = this.props

        const locationPath = location ? location.pathname : ''

        let logo = `${this.config.REACT_APP_SFN_IMAGES_FOLDER}sfn-logo.svg`

        switch (this.config.REACT_APP_SYSTEM) {
            case 'sportuj_v_ostrave':
                logo = logoOstrava
                break
            case 'sportuj_v_olomouci':
                logo = logoOlomouc
                break
            case 'sportuj_v_chebu':
                logo = logoCheb
                break
        }

        return (
            <Link
                to={authedUser ? '/' : '/sfn'}
                className={classnames({
                    'mr-1 mr-sm-4': true,
                    'logo': logo === logoSnect,
                    'm-auto': !authedUser && locationPath === '',
                    'logo--full': logo === logoSnect && !authedUser,
                })}
                onClick={() => this.toggleResponsiveMenu(false)}
            >
                <img src={logo} alt="logo" />
            </Link>
        )
    }

    /**
     * Render only first letter of surname
     * @param {string} surname
     * @returns {*}
     */
    renderShortSurname = surname => surname.substr(0,1)

    renderLoginModalPop = () => {
        const {
            login,
            t,
        } = this.props

        const { loginRoute } = this.config

        if (!login.modalVisible) {
            return null
        }

        return (
            <div className="position-relative">
                <div
                    className="Navbar-login__overlay"
                    onClick={() => store.dispatch({ type: 'TOGGLE_LOGIN_MODAL' })}
                />
                <div className="Navbar-login__modal-pop p-3">
                    <div className="d-flex align-items-end flex-column">
                        <h3 className="w-100 text-center">
                            {t('youAreNotLoggedIn')}
                        </h3>
                        <div className="text-center w-100 pb-2">
                            {login.modalText}
                        </div>
                        <div className="d-flex justify-content-between w-100">
                            <Button
                                onClick={() => store.dispatch({ type: 'TOGGLE_LOGIN_MODAL' })}
                                className="btn btn-outline-color-negative btn-lg mt-2"
                            >
                                {t('notNow')}
                            </Button>
                            {(this.config.REACT_APP_SYSTEM !== S_SPORTNECT) && (
                                <Button
                                    onClick={() => {
                                        store.dispatch({ type: 'TOGGLE_LOGIN_MODAL' })
                                        setSuccessAction()
                                        setSystemRedirectLinks(null, loginRoute, true)
                                    }}
                                    className="btn btn-outline-color-brand btn-lg mt-2"
                                >
                                    {t('login')}
                                </Button>
                            )}
                            {(this.config.REACT_APP_SYSTEM === S_SPORTNECT) && (
                                <Link
                                    to={{
                                        pathname: !this.isSfnType() ? loginRoute : loginRoute + SFN_TYPE,
                                    }}
                                    onClick={setSuccessAction}
                                    className="btn btn-outline-color-brand btn-lg mt-2"
                                >
                                    {t('login')}
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    /**
     * Render search button
     * @returns {*}
     */
    renderSearchButton = () => {
        const { t } = this.props

        return (
            <Link
                className="icon-link p-0"
                title={t('searchLabel')}
                to={`/${this.config.REACT_APP_TRANSLATION_ROUTES.entities}`}
            >
                <SnIcon className="sn-search" />
                <p>{t('searchLabel')}</p>
            </Link>
        )
    }

    /**
     * Render profile link content
     *
     * @returns {*}
     */
    renderProfileLinkContent = () => {
        const {
            t,
            authedUser,
        } = this.props

        return (
            <Fragment>
                <ImageResized
                    src={authedUser?.image?.data?.path}
                    size="avatar"
                    alt="profile"
                    defaultSrc={userDefaultLogo}
                />
                <p>{t('me')}</p>
            </Fragment>
        )
    }

    /**
     * Check if can show entities stripe
     *
     * On desktop
     * For Sportnect is showed if page is list of some entity (eg. All, Events, Clubs,...) and user is logged
     * For Cities  is visible always
     *
     * In responsive
     * For Sportnect and Cities is visible if page is list of some entity (eg. All, Events, Clubs,...)
     *
     * @param {string} locationPath
     * @param {boolean} isResponsive
     * @return {boolean}
     */
    canShowEntitiesStripe = (locationPath = '', isResponsive) => {
        const { REACT_APP_TRANSLATION_ROUTES: routes } = this.config

        if (!isResponsive) {
            return true
        }

        const locationPathWithoutSlash = locationPath.replace('/', '')
        return Object.values(routes).some(item => item === locationPathWithoutSlash)
    }

    /**
     ** Render responsive variant of menu
     *
     * @param {string} locationPath
     * @return {*}
     */
    renderResponsiveMenu = locationPath => {
        const {
            authedUser,
            t,
        } = this.props

        return (
            <div className="Navbar__responsive">
                <div className={classnames({
                    'Navbar__responsive-container': true,
                    'justify-content-center': !authedUser && locationPath === '',
                    'justify-content-between': !authedUser && locationPath !== '',
                })}>
                    <span className="Navbar__responsive-container-logo">{this.renderMenuLogo()}</span>

                    {authedUser &&
                        <div className="Navbar__responsive-container-box">
                            <ul className="Navbar__responsive-container--links">
                                <li>
                                    <div
                                        className="icon-link"
                                        title={t('home')}
                                        onClick={() => logout(false, true)}
                                    >
                                        <SnIcon className="sn-avatar" />
                                        <p>Log out</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    }
                    {!authedUser &&
                        <div className="Navbar__container-landing-page">
                            <LoginButton fromSfn />
                        </div>
                    }
                </div>
            </div>
        )
    }

    /**
     * Render desktop variant of menu
     *
     * @return {*}
     */
    renderMainMenu = () => {
        const { authedUser } = this.props

        const { showMenuResponsive } = this.state

        return (
            <Fragment>
                <div className={classnames({
                    'Navbar': true,
                    'Navbar__responsive-content': showMenuResponsive,
                })}>
                    <div
                        className={classnames({
                            'Navbar__container position-relative': true,
                            'justify-content-between': !authedUser,
                            'container': !this.isResponsiveMenu(),
                        })}
                    >
                        <div className="d-none d-flex align-items-center">
                            {!showMenuResponsive && this.renderMenuLogo()}
                        </div>

                        {authedUser &&
                            <ul className="Navbar__container--links">
                                <li>
                                    <a
                                        className="icon-link"
                                        onClick={() => logout(false, true)}
                                    >
                                        <SnIcon className="sn-avatar" />
                                        <p>Log out</p>
                                    </a>
                                </li>
                            </ul>
                        }

                        {!authedUser &&
                            <div className="Navbar__container-landing-page">
                                <LoginButton fromSfn />
                            </div>
                        }
                    </div>
                </div>
            </Fragment>
        )
    }

    render() {
        const { location } = this.props

        const locationPath = location ? location.pathname : ''

        return (
            <Fragment>
                <nav className="d-inline-flex">
                    {this.renderResponsiveMenu(locationPath)}
                    {this.renderMainMenu()}
                </nav>
            </Fragment>
        )
    }
}

function mapStateToProps({
    auth,
    app,
}) {
    return {
        authedUser: auth.user,
        login: app.login,
    }
}

export default withRouterConnectWrapper(mapStateToProps)(SFNHeader)
